import kb from '../helpers/kb';

const hsl2rgb = ({ hue, saturation, lightness, alpha }) => {
  const b = (1 - Math.abs(2 * lightness - 1)) * saturation;
  return kb(hue, alpha, b, Math.max(0, lightness - b / 2));
};

export default hsl2rgb;
